var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Refresh icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 11.0347V17.9329C30 18.5063 29.5388 18.9676 28.9655 18.9676H22.069C21.5 18.9676 21.0345 18.5063 21.0345 17.9329C21.0345 17.3595 21.4978 16.8982 22.069 16.8982H26.4009C25.1207 14.4105 22.5216 12.7593 19.6552 12.7593C15.4353 12.7593 12.069 16.1264 12.069 20.3472C12.069 24.568 15.4728 27.9352 19.6552 27.9352C21.4263 27.9352 23.1504 27.3114 24.5086 26.1783C24.9466 25.8119 25.5996 25.8698 25.9659 26.3103C26.3323 26.7497 26.2731 27.4016 25.834 27.768C24.1029 29.2097 21.9042 30 19.6486 30C14.3276 30.0003 10 25.6718 10 20.3472C10 15.0227 14.3276 10.6941 19.6509 10.6941C23.0927 10.6941 26.2198 12.5678 27.931 15.3978V11.0347C27.931 10.4635 28.3944 10 28.9655 10C29.5366 10 30 10.4635 30 11.0347Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.69fdf80204fd768eb31fd9ca479d00f8.svg";
export { ForwardRef as ReactComponent };